import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DialogService } from '../dialog/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '../_services/loading.service';
import { LoggerService } from '../_services/logger.service';
import { AuthenticationService } from '../_services/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private dialogService: DialogService,
    private loadingService: LoadingService,
    private logger: LoggerService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let mensagem = '';

        if (error.status === 403) {
          mensagem = this.translate.instant('Você não tem permissão para acessar este recurso.');
          this.logger.error('Erro 403 - Acesso negado', error);
          this.authenticationService.logout();

          this.dialogService.abrirDialog(
            'erro',
            this.translate.instant('Acesso negado'),
            mensagem
          );
        }
        else if (error.status === 404) {
          mensagem = this.translate.instant('Recurso não encontrado.');
          this.logger.error('Erro 404 - Não encontrado', error);
        }
        else if (error.status === 500) {
          mensagem = this.translate.instant('Erro interno no servidor. Tente novamente mais tarde.');
          this.logger.error('Erro 500 - Erro interno', error);
        }
        else if (error.status !== 401) {
          console.log('Erro 401:', error);
          // 401 já tratado pelo JwtInterceptor
          mensagem = error.error?.message || this.translate.instant('Erro inesperado.');
          this.logger.error('Erro HTTP', error);
        }

        this.loadingService.hide();

        return throwError(() => error); // repassa erro original
      })
    );
  }
}
